export default __webpack_public_path__ + "static/media/Completed.d3c92e00.svg";